<template>
  <div class='step5'>
    <dict-item-texts></dict-item-texts>
    <a-row type='flex' :gutter='24'>
      <a-col flex='3' style='width: 0'>
        <p v-for='(con, i) in conditions'>
          <a-space :size='12'>
            <a-select v-if='i > 0' v-model='con.or' style='width: 60px'>
              <a-select-option value='and'>且</a-select-option>
            </a-select>
            <a-select placeholder='请选择数据源' v-model='con.field' style='width: 200px'></a-select>
            <a-select v-model='con.con' style='width: 80px'>
              <a-select-option value='<'>小于</a-select-option>
              <a-select-option value='>'>大于</a-select-option>
              <a-select-option value='=='>等于</a-select-option>
              <a-select-option value='!='>不等于</a-select-option>
              <a-select-option value='<='>小于等于</a-select-option>
              <a-select-option value='>='>大于等于</a-select-option>
            </a-select>
            <a-input v-model='con.value' style='width: 80px'></a-input>
            <a-icon v-if='i > 0' type="close" @click='removeCondition(i)'/>
            <a-icon type="plus-circle" @click='addCondition()'/>
          </a-space>
        </p>
      </a-col>
      <a-col flex='2' style='width: 0'>
        <a-card>
          <div class='data-source-container-title'>数据源</div>
          <a-space :size='16'>
            <a-button type="primary" @click='write'>【入院术前评估.入院日期.基线周期】</a-button>
            <!--字典项元素数据源-->
            <a-dropdown-button type='primary' @click='write'>
              【xxxxx.xxxxx.xxxxx】
              <a-menu slot="overlay">
                <a-menu-item key="1"> <a-icon type="user" />字典项文本1</a-menu-item>
                <a-menu-item key="2"> <a-icon type="user" />字典项文本2</a-menu-item>
                <a-menu-item key="3"> <a-icon type="user" />字典项文本3</a-menu-item>
              </a-menu>
              <a-icon slot="icon" type="down" />
            </a-dropdown-button>
          </a-space>
        </a-card>
      </a-col>
    </a-row>
  </div>
</template>

<script>
export default {
  name: 'Step5',
  props: ['model'],
  data() {
    return {
      currentEditIndex: null,
      conditions: [{}]
    }
  },
  methods: {
    addCondition(i) {
      this.conditions.push({field: '', con: '', value: '', or: ''})
    },
    removeCondition(i) {
      if (this.conditions.length > 1) {
        this.conditions.splice(i, 1)
      }
    },
    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      //  可跳过,无需验证
      return true
    }

  }
}
</script>

<style scoped>
.data-source-container-title {
  border-left: 4px solid rgb(34, 144, 255);
  padding-left: 8px;
  font-size: 18px;
  font-weight: bold;
  background: #F8F8F8;
  margin-bottom: 8px;
}

.ant-row-flex .ant-card {
 margin: 20px 0;
}

</style>
